/* eslint-disable array-callback-return */
/* eslint-disable react/prop-types */
import { useEffect, useState } from 'react';
import { useLocales } from '../../locales';
import PlaceholderImage from '../../assets/images/image-place-holder.jpg';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import {
  IS_DOWNLOADABLE_ICON,
  IS_SHAREABLE_ICON,
  IS_STORY_ICON, PLATFORM_COLORS,
  PLATFORM_ICONS
} from '../../config/icons';
import IsLoadingIndicator from '../isLoadingIndicator';

import placeholderBlue from '../../assets/images/placeholders/posts/placeholder_post_blue.png';
import placeholderGrey from '../../assets/images/placeholders/posts/placeholder_post_grey.png';
import placeholderYellow from '../../assets/images/placeholders/posts/placeholder_post_yellow.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';

const PLACEHOLDERS = {
  last_published_post: placeholderBlue,
  best_performance_post: placeholderBlue,
  next_to_publish_post: placeholderGrey,
  last_edited_post: placeholderYellow
};

const SHOW_ICON_TYPES = ['best_performance_post'];

const getInfoIconState = (item) => {
  return SHOW_ICON_TYPES.indexOf(item.post_type_title) > -1;
};

// eslint-disable-next-line react/prop-types
const PostCard = ({ posts }) => {
  const { translate: t, currentLang } = useLocales();

  const [activeIndex, setActiveIndex] = useState(0);
  const [showInfoIcon, setShowInfoIcon] = useState(false);

  useEffect(() => {
    setShowInfoIcon(getInfoIconState(posts[activeIndex]));
  });
  if (!posts)
    return (
      <div className="card shadow rounded h-100">
        <IsLoadingIndicator />
      </div>
    );
  return (
    <div className="card shadow rounded h-100">
      <div className="card-header  d-flex border-0 px-1">
        <div className="card-title ml-auto p-2">
          {posts.length > 1 ? (
            <div className="dropdown">
              <button
                className="btn btn-sm btn-color-muted btn-active btn-active-light fw-bold px-4 me-1 active dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {t(posts[activeIndex].post_type_title)}
              </button>
              <ul
                className="dropdown-menu"
                aria-labelledby="dropdownMenuButton"
              >
                {posts.map((item, i) => {
                  return (
                    <li className="nav-item" key={i}>
                      <a
                        className={`dropdown-item ${
                          i === activeIndex ? 'active' : ''
                        }`}
                        onClick={() => setActiveIndex(i)}
                      >
                        {t(item.post_type_title)}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          ) : (
            <div
              className={`btn btn-sm btn-color-muted btn-active btn-active-light fw-bold px-4 me-1 ${
                activeIndex === 0 ? 'active' : ''
              }`}
              onClick={() => setActiveIndex(0)}
            >
              {t(posts[0].post_type_title)}
            </div>
          )}
        </div>
        {showInfoIcon && (
          <div className={'card-toolbar'}>
            <div className={'me-2'}>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>{t('topPosts.timerange_info')}</Tooltip>}
              >
                <FontAwesomeIcon
                  icon={duotone('circle-info')}
                  size="1x text-muted"
                />
              </OverlayTrigger>
            </div>
          </div>
        )}{' '}
      </div>
      {posts.map((item, i) => {
        if (i === activeIndex && item.placeholder)
          return (
            <div
              className="card-body pt-0 justify-content-center d-flex align-items-center"
              key={i}
            >
              <div className="justify-center d-flex flex-column align-items-center p-2 rounded">
                <img
                  src={PLACEHOLDERS[item.post_type_title]}
                  alt="placeholder"
                  className={'mw-100'}
                />
                <div className={'mt-2 text-muted'}>
                  {t(`topPosts.no_${item.post_type_title}`)}
                </div>
              </div>
            </div>
          );

        if (i === activeIndex && !item.placeholder)
          return (
            <>
              <div
                className="card-body pt-0 cursor-pointer"
                key={i}
                onClick={() => (window.location.href = item.url)}
              >
                <div className="d-flex justify-content-between mb-1">
                  <div>
                    {!item.created_in_lomavis && (
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>{t('post_is_imported')}</Tooltip>}
                      >
                        <i className={`${IS_DOWNLOADABLE_ICON} me-2`}></i>
                      </OverlayTrigger>
                    )}
                    {item.content_type_is_story_post && (
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>{t('post_is_story')}</Tooltip>}
                      >
                        <i className={`${IS_STORY_ICON} me-2`}></i>
                      </OverlayTrigger>
                    )}
                  </div>
                  <div>
                    {item.published_on_platform_dict?.map((platform) => {
                      return (
                        <OverlayTrigger
                          key={platform}
                          placement="top"
                          overlay={<Tooltip>{t(platform)}</Tooltip>}
                        >
                                                    <i className={`${PLATFORM_ICONS[platform]} me-2`} style={{fontSize: 20, color: PLATFORM_COLORS[platform]}}></i>
                        </OverlayTrigger>
                      );
                    })}
                    {item.is_shared_post && (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip>{t('post_types.post_is_shareable')}</Tooltip>
                        }
                      >
                        <i className={`${IS_SHAREABLE_ICON} me-2`}></i>
                      </OverlayTrigger>
                    )}
                  </div>
                </div>
                <div
                  className="h-300px mb-3 d-flex justify-content-center align-items-center rounded "
                  style={{ position: 'relative', overflow: 'hidden' }}
                >
                  <div className="w-100 h-100 position-relative d-flex justify-content-center align-items-center">
                    <img
                      className="mw-100 mh-100 overlay img-thumbnail rounded"
                      src={item.preview_image_url || PlaceholderImage}
                      alt="Post"
                      style={{ objectFit: 'contain' }}
                    />
                    {item.is_video ? (
                      <i
                        className="fa-duotone fa-circle-play text-white"
                        style={{
                          fontSize: 50,
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)'
                        }}
                        aria-hidden="true"
                      ></i>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
                {item.text ? (
                  <div style={{ height: 103, overflow: 'hidden' }}>
                    <p dangerouslySetInnerHTML={{ __html: item.text }}></p>
                  </div>
                ) : (
                  item.is_shared_post && (
                    <div
                      className="text-muted text-center"
                      style={{ height: 103, overflow: 'hidden' }}
                    >
                      {t('topPosts.post_is_shared_without_comment')}
                    </div>
                  )
                )}
              </div>
              <div
                className={`card-footer py-2 d-flex justify-content-between`}
              >
                {item.show_metrics ? (
                  <div className="d-flex w-75">
                    <div className="d-flex align-items-center justify-content-center me-2">
                      <span>
                        <i
                          className="fa-duotone fa-heart text-danger fs-base"
                          style={{
                            verticalAlign: 'middle',
                            display: 'inline-block'
                          }}
                        ></i>
                      </span>
                      <span className="ms-2 small">
                        {new Intl.NumberFormat(currentLang.systemValue, {
                          notation: 'compact',
                          compactDisplay: 'short'
                        }).format(item.impressions)}
                      </span>
                    </div>
                    <div className="d-flex align-items-center justify-content-center">
                      <span>
                        <i
                          className="fa-duotone fa-eye text-primary"
                          style={{
                            verticalAlign: 'middle',
                            display: 'inline-block'
                          }}
                        ></i>
                      </span>
                      <span className="ms-2 small">
                        {new Intl.NumberFormat(currentLang.systemValue, {
                          notation: 'compact',
                          compactDisplay: 'short'
                        }).format(item.views)}
                      </span>
                    </div>
                  </div>
                ) : (
                  ''
                )}
                <div className="d-flex justify-content-end text-muted">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip>
                        {new Date(item.date).toLocaleString(
                          currentLang.systemValue,
                          {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                            hour: 'numeric',
                            minute: 'numeric'
                          }
                        )}
                      </Tooltip>
                    }
                  >
                    <span>
                      {new Date(item.date).toLocaleString(
                        currentLang.systemValue,
                        {
                          month: 'short',
                          day: 'numeric'
                        }
                      )}
                    </span>
                  </OverlayTrigger>
                </div>
              </div>
            </>
          );
      })}
    </div>
  );
};

export default PostCard;
